export default "__VITE_PUBLIC_ASSET__bb8913d4__"